<template>
    <Sheet v-loading="loading.actions['setting']">
        <el-tabs value="sys">
            <el-tab-pane label="系統參數設定" name="sys" lazy>
                <sys-form></sys-form>
            </el-tab-pane>
            <el-tab-pane label="紡織專班參數設定" name="industry" lazy>
                <industry-form></industry-form>
            </el-tab-pane>
            <el-tab-pane label="信件設定" name="template" lazy>
                <mail-setting></mail-setting>
            </el-tab-pane>
            <el-tab-pane label="特殊時段設定" name="summer" lazy>
                <special-time-setting :loading="loading.actions['setting']"></special-time-setting>
            </el-tab-pane>
            <el-tab-pane label="教室設定" name="room" lazy>
                <room-setting></room-setting>
            </el-tab-pane>
        </el-tabs>
    </Sheet>
</template>

<script>
    import {mapState} from 'vuex';
    import SysForm from './SysForm';
    import MailSetting from './MailSetting';
    import IndustryForm from './IndustryForm';
    import SpecialTimeSetting from './SpecialTimeSetting';
    import RoomSetting from './RoomSetting';

    export default {
        name: 'Setting',
        components: {
            MailSetting,
            SysForm,
            IndustryForm,
            SpecialTimeSetting,
            RoomSetting,
        },
        computed:{
            ...mapState(['loading']),
        }
    }
</script>

<style scoped>

</style>